import * as React from 'react';
import { ChecklistEnum } from './model';
import styles from './index.module.css';

import step1CreateProject from 'appAssets/animations/step1_createProject.mp4';
import step2Js from 'appAssets/animations/step2_js.mp4';
import step2Extensions from 'appAssets/animations/step2_extension.mp4';
import step3TryBugHerd from 'appAssets/animations/step3_tryBugHerd.mp4';

interface AnimationProps {
  step: ChecklistEnum;
  showEmbedJavascript?: boolean;
}

const Animation: React.FC<AnimationProps> = ({ step, showEmbedJavascript }) => {
  return (
    <div className={styles.animationContainer}>
      <video
        className={styles.animationMedia}
        autoPlay
        loop
        muted
        src={
          [
            step1CreateProject,
            showEmbedJavascript ? step2Js : step2Extensions,
            step3TryBugHerd
          ][step]
        }
      />
    </div>
  );
};

export default Animation;
